import React from 'react'
import {Circle, Layer, Stage, Text} from "react-konva";
import Konva from "konva";
import KonvaEventObject = Konva.KonvaEventObject;

const pulseShape = (shape, isShapeClicked) => {
    // use Konva methods to animate a shape
    const fillColor = isShapeClicked ? 'green' : 'red';
    shape.to({
        scaleX: 1.5,
        scaleY: 1.5,
        fill: fillColor,
        onFinish: () => {
            shape.to({
                scaleX: 1,
                scaleY: 1,
            });
        },
    });
};

const KonvaReference = () => {
    const circleRef = React.useRef(null);

    const handleStageClick = () => {
        // this event demonstrates how to access Konva node using ref
        const shape = circleRef.current;
        pulseShape(shape, false);
    };

    const handleCircleClick = (e) => {
        // another way to access Konva nodes is to just use event object
        const shape = e.target;
        pulseShape(shape, true);
        // prevent click on stage
        e.cancelBubble = true;
    };

    const handleCursor = (event: KonvaEventObject<MouseEvent>) => {
        const stage = event.target.getStage();
        if (stage) {
            if (event.type === "mouseenter") {
                stage.container().style.cursor = "pointer";
            } else {
                stage.container().style.cursor = "default";
            }
        }
    };

    return (
        <>
            <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                   onClick={handleStageClick}
                   onTap={handleStageClick}
                   className="">
                <Layer>
                    <Text
                        x={50}
                        y={50}
                        fontSize={20}
                        text="Click on any place to see an animation"/>
                    <Circle
                        ref={circleRef}
                        x={window.innerWidth / 3}
                        y={window.innerHeight / 3}
                        radius={80}
                        fill="red"
                        onClick={handleCircleClick}
                        onTap={handleCircleClick}
                        onMouseEnter={handleCursor}
                        onMouseLeave={handleCursor}
                    />
                </Layer>
            </Stage>
        </>
    )
}

export default KonvaReference
